const mutations = {
    changetoken(state, val) {
        state.token = val
        return state.token
    }
}
export default mutations


// WEBPACK FOOTER //
// ./src/store/mutations.js